import signIn from './functions/signIn';
import signUp from './functions/signUp';

const auth = {
  signIn: signIn,
  signUp: signUp
};

export default auth;
